import React, { Fragment } from "react";
import { Fade } from "react-reveal";

export default class ReadMe extends React.Component {
  render() {
    return (
      <Fade bottom duration={1000} distance="40px">

      <Fragment>
        <div className="container text-center mt-10 d-flex flex-column ">
          <span className="projects">
            My presentations
          </span>

        </div>

        <div className="container mt-5 mb-5 read-me flex-wrap justify-content-center">

          <div className="m-2 d-flex flex-column align-items-center">
            <div className="box ">
              <div className="little-box">
                <span> 2019 </span>
              </div>
              <img class="card-img-top" src={require('../static/img/work/s1.png')} alt="Card image cap" />

            </div>
            <div className="pt-2 pb-2 d-flex flex-column like-box justify-content-center">
              <span className="card-title "> MLAAS</span>
              <span className="card-category ">Cloud , IT , AI , ML </span>
              <span className="card-category ">
              </span>
            </div>
            <div className=" m-4 justify-content-start">
              <a href='https://www.slideshare.net/TakwaChaabane/machine-learning-as-a-service-mlaas-124943324' target="_blank">
                <span className="btn-none-rounded  btna">check it</span>

              </a>
            </div>
          </div>

          <div className="m-2 d-flex flex-column align-items-center">
            <div className="box ">

              <div className="little-box">
                <span> 2018 </span>

              </div>
              <img class="card-img-top" src={require('../static/img/work/s2.png')} alt="Card image cap" />

            </div>
            <div className="pt-2 pb-2 d-flex flex-column like-box justify-content-center">

              <span className="card-title ">Big data & Cloud computing </span>
              <span className="card-category "> DB , engineering </span>
              <span className="card-category ">

              </span>
            </div>
            <div className=" m-4 justify-content-start">
              <a href='https://www.slideshare.net/TakwaChaabane/big-data-94116334' target="_blank" >
                <span className="btn-none-rounded btna">check it</span>

              </a>   </div>
          </div>
          <div className="m-2 d-flex flex-column align-items-center">
            <div className="box ">
              <div className="little-box">
                <span> 2018 </span>

              </div>
              <img class="card-img-top" src={require('../static/img/work/s3.png')} alt="Card image cap" />

            </div>
            <div className="pt-2 pb-2 d-flex flex-column like-box justify-content-center">

              <span className="card-title ">Big data</span>
              <span className="card-category "> DB , engineering </span>
              <span className="card-category ">

              </span>
            </div>
            <div className=" m-4 justify-content-start">
              <a href='https://www.slideshare.net/TakwaChaabane/cloud-computing-et-big-data' target="_blank">
                <span className="btn-none-rounded btna">check it</span>

              </a>               </div>
          </div>
        </div>

      </Fragment>

      </Fade>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReadMe.js